// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5":"55c74185cf","532":"45bc800c76"}[chunkId] + ".css";
};